import Scene = Phaser.Scene;
import {lazyInject} from "@/container";
import {TYPES} from "@/types";
import {SceneService} from "@/services/scene-service";
import SceneUtils from "@/utils/scene-utils";
import {LoadUtils, LoaderState} from "@/utils/load-utils";
import {LoadFixer} from "@/utils/load-fixer";
import {SceneName} from "@/model/scene-name";

export default class BootFixScene extends Scene {

    @lazyInject(TYPES.SceneService)
    private sceneService!: SceneService;

    private canvas!: HTMLCanvasElement;

    private static RELOAD: boolean = false;
    private static RELOADS_COUNT: number = 0;
    private static readonly MAX_RELOADS_COUNT: number = 3;

    private loaderState!: LoaderState;

    constructor() {
        super({ key: 'BootFixScene' });
    }

    public preload(): void {

        this.canvas = this.sys.game.canvas;

        this.loaderState = new LoaderState();
        LoadUtils.showLoadingScreen(this, this.canvas, this.loaderState);
        SceneUtils.setCurrentScene(this);

        let errs: any[] = LoadFixer.LOAD_ERRORS;
        LoadFixer.LOAD_ERRORS = [];

        this.load.addListener(Phaser.Loader.Events.FILE_LOAD_ERROR, (err: any) => {
            LoadFixer.LOAD_ERRORS.push(err)
            BootFixScene.RELOAD = true;
        });

        let atlasKeys: string[] = []
        for (let e of errs) {
            if (e.type === 'json') {
                this.load.atlas(e.key, e.url.substring(0, e.url.length - 'json'.length) + 'png', e.url);
                atlasKeys.push(e.key);
            }
        }

        for (let e of errs) {
            if (atlasKeys.includes(e.key)) {
                continue;
            }
            if (e.type === 'image') {
                // console.log('Reloading image ' + e.key);
                this.load.image(e.key, e.url);
            } else if (e.type === 'spritesheet') {
                // console.log('Reloading spritesheet ' + e.key);
                this.load.spritesheet(e.key, e.url, e.config);
            } else if (e.type === 'audio') {
                // console.log('Reloading audio ' + e.key);
                this.load.audio(e.key, e.url);
            } else {
                console.log('Reloading ... what?? ');
                console.log(e);
                console.log('????????????????????');
            }
        }
    }

    public create(): void {
        if (BootFixScene.RELOAD && BootFixScene.RELOADS_COUNT < BootFixScene.MAX_RELOADS_COUNT) {
            BootFixScene.RELOAD = false;
            BootFixScene.RELOADS_COUNT += 1;
            this.sceneService.startSceneInstant(this, SceneName.BOOT_FIX_SCENE);
        } else {
            LoadUtils.goToNewSceneAfterLoad(this, this.sceneService);
        }
    }

    update(time: number, delta: number) {
        this.loaderState.update(time, delta);
    }

}
